//import React from 'react';
//import { connect } from "react-redux";
//import { pushItem } from "../../stores/cartActions.js";
//import gommeStore from "../../stores/gomme-store.js";
//import { setTimeout } from 'timers';

const trackThis = (data) => {

  console.log("trackThis", data);

  const { target, cart, cartid, tireresult, wheelresult, spareresult, kitresult } = data;
  //ugly

  //if (typeof window.gtag !== 'undefined') {
  var goalTracking = new Promise((resolve, reject) => {

    if (typeof window.gtag !== 'undefined') {
      var to = window.setTimeout(() => {
        console.log("google goal tracking", "timed out !!!");
        resolve({ prom: 'analytics', failed: true });
      }, 5000);

      // GOOGLE ANALYTICS TRACKING
      //const UIDAnalytics = window.site_config.gtag.UIDAnalytics
      //var goal = null;
      //switch (target) {
      //  case "kit":
      //    goal = "/add-to-cart-kit";
      //    break;
      //  case "tire":
      //    goal = "/add-to-cart-tires";
      //    if (tireresult && tireresult.brandid == "MIC") {
      //      //goal = "/add-to-cart-tires-michelin";
      //      gtag('config', UIDAnalytics, {
      //        'page_path': "/add-to-cart-tires-michelin" + '?cartid=' + cartid
      //      });
      //      console.log("google", "analytics", "/add-to-cart-tires-michelin");
      //    }
      //    break;
      //  case "wheel":
      //    goal = "/add-to-cart-wheels";
      //    break;
      //  case "spare":
      //    goal = "/add-to-cart-spare";
      //    break;
      //}

      //gtag('config', UIDAnalytics, {
      //  'page_path': goal + '?cartid=' + cartid
      //});
      //console.log("google", "analytics", goal);

      //var items = [];
      //if (tireresult) {
      //  var v = tireresult;
      //  items.push({
      //    //"id": v.cai,
      //    "id": v.hash,
      //    "name": v.width + '|' + v.ratio + '|' + v.diameter,
      //    "brand": v.brandid,
      //    "category": "tires",
      //    "quantity": 4//,
      //    //"price": v.GATRAI.replace(',', '.')
      //  });
      //} else if (wheelresult) {
      //  var v = wheelresult;
      //  items.push({
      //    "id": v.WheelId.trim(),
      //    "name": v.Model + '|' + v.Color + '|' + v.Holes + '|' + v.Diameter,
      //    "brand": v.Brand,
      //    "category": "wheels",
      //    "quantity": 4//,
      //    //"price": v.GATRAI.replace(',', '.')
      //  });
      //} else if (spareresult) {
      //  var v = spareresult;
      //  items.push({
      //    // "id": v.???.trim(),
      //    "name": v.Model,
      //    "brand": v.Brand,
      //    "category": "spare",
      //    "quantity": 1//,
      //    //"price": v.GATRAI.replace(',', '.')
      //  });
      //} else if (kitresult) {
      //  var v = kitresult;
      //  items.push({
      //    // "id": v.???.trim(),
      //    "name": v.description,
      //    "brand": v.brand,
      //    "category": "kit",
      //    "quantity": 4//,
      //    //"price": v.GATRAI.replace(',', '.')
      //  });
      //}

      //// GOOGLE ANALYTICS TRACKING - ECOMMERCE
      //gtag('event', 'add_to_cart', {
      //  //"transaction_id": cart.cartid,
      //  //"affiliation": window.location.hostname,
      //  "items": items,
      //  'event_callback': () => {
      //    resolve({ prom: 'analytics', failed: false, success: true });
      //    clearTimeout(to);
      //  }
      //});
    }
  });

  return goalTracking;

  //return goalTracking.then((d) => {
  //  console.log("google goal tracking", d);
  //  //we must wait 250ms because redux state to localstorage is debounced for 250ms
  //  setTimeout(() => {
  //    console.log("redirect now", d);
  //    //window.location.href = "/cart"
  //  }, 250);
  //});

  //} else {
  //  setTimeout(() => {
  //    console.log("redirect");
  //    //window.location.href = "/cart"
  //  }, 250);
  //}

}

export { trackThis }
